import { requestCustomerApi } from './requestApi'
import { ApiCustomerConfiguration } from '@app/types/customerConfiguration'

export const getCustomerConfiguration = async (): Promise<ApiCustomerConfiguration> =>
  await requestCustomerApi({
    method: 'GET',
    path: 'configuration',
    resourceName: 'configuration',
  })
